/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated';
import { createConstantNode } from '../../factoriesAny.js';
export var ConstantNodeDependencies = {
  NodeDependencies: NodeDependencies,
  createConstantNode: createConstantNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesConstantNode.generated.js
// module id = 164
// module chunks = 0